import { SiteOID } from 'app/site-detail/models/Site';

export type NotificationId = string;

export enum NotificationSourceType {
    INSTALLER_DETACHED = 'installerDetached',
    LINK_REQUEST_ACCEPTED = 'linkRequestAccepted',
    LINK_REQUEST_REJECTED = 'linkRequestRejected',
    LINK_REQUEST_REMINDER = 'linkRequestReminder',
    ALERT_REMINDER = 'alertReminder',
    FREE_NOTIFICATION = 'freeNotification',
    INTERVENTION_EXPIRED = 'interventionExpired',
}

export interface NotificationOwner {
    firstName: string;
    lastName: string;
}

export interface SiteEventNotificationData {
    owner: NotificationOwner;
    gateways: string[];
}

export interface FreeNotificationData {
    title: string;
    text: string;
}

export interface LinkRequestReminderData {
    linkRequestOID: string;
    owner: NotificationOwner;
}

export interface AlertReminderData {
    alertCount: number;
}

export interface InterventionExpiredData {
    owner: NotificationOwner;
    siteOID: SiteOID;
}

export type NotificationContent = { date?: number } & (
    | { type: NotificationSourceType.INSTALLER_DETACHED; data: SiteEventNotificationData }
    | { type: NotificationSourceType.LINK_REQUEST_ACCEPTED; data: SiteEventNotificationData }
    | { type: NotificationSourceType.LINK_REQUEST_REJECTED; data: SiteEventNotificationData }
    | { type: NotificationSourceType.LINK_REQUEST_REMINDER; data: LinkRequestReminderData }
    | { type: NotificationSourceType.ALERT_REMINDER; data: AlertReminderData }
    | { type: NotificationSourceType.FREE_NOTIFICATION; data: FreeNotificationData }
    | { type: NotificationSourceType.INTERVENTION_EXPIRED; data: InterventionExpiredData }
);

export interface NotificationDto {
    id: NotificationId;
    date?: number;
    read: boolean;
    notification: NotificationContent;
}
